import { ButtonV2 } from '@cimplico/components';
import { CloudArrowDownIcon } from '@heroicons/react/20/solid';
import { useParams } from 'react-router-dom';
import DocumentRenderer from '../components/document-browser/DocumentRenderer';
import { FYI_URL } from '../config';
import { useFileRecord } from '../queries/use-file-record';
import FYILogo from '../assets/fyi.png';
import { FileRecordTypeEnum } from '../types/file-record';
import { toastNotification } from '../components/toast/Toast';
import { downloadDocument } from '../utilities/document-download';
import { useDownloadLink } from '../queries/use-download-link';

function DocumentViewer(): JSX.Element {
    const { recordId } = useParams<{ recordId: string }>();
    const downloadQuery = useDownloadLink(recordId ? [recordId] : [], false);

    const recordQuery = useFileRecord(recordId);
    const record = recordQuery.data?.file;

    async function download(): Promise<void> {
        try {
            const res = await downloadQuery.refetch();
            const urls = res.data?.urls ?? [];

            const url = urls[0]?.url;

            if (url && record) {
                downloadDocument(record?.name, url);
            }
        } catch (error) {
            toastNotification('error', 'Unable to download document. Something went wrong');
        }
    }

    if (!record) {
        return <></>;
    }

    const isFYI = (record?.source ?? record)?.recordType === FileRecordTypeEnum.FYI_DOCUMENT;
    const metadata = (record?.source ?? record)?.metadata;

    return (
        <div className="h-screen">
            {/* Top bar with details */}
            <div className="flex items-center w-full h-12 px-4 border-b">
                <div className="flex-1">
                    <p className="text-gray-700 max-w-[1/2] line-clamp-1 break-all font-bold">{record.name}</p>
                </div>
                <div className="flex items-center mr-2">
                    {isFYI && (
                        <>
                            <a
                                className="text-sm text-gray-600 flex items-center hover:underline pr-2 mr-2 border-r"
                                href={`${FYI_URL}/documents/${metadata?.id}/preview`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src={FYILogo} className="h-5 w-5 mr-1" />
                                View in FYI
                            </a>
                        </>
                    )}

                    <ButtonV2 size="sm" type="secondary" leftIcon={<CloudArrowDownIcon />} label="Download" onClick={download} />
                </div>
            </div>
            <DocumentRenderer record={record} onDownload={download} />
        </div>
    );
}
export default DocumentViewer;
